import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">
          精彩推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12 max-w-xl mx-auto">
          编辑精选高分佳作，每日为你推荐值得看的优质内容
        </p>
        <div className="space-y-5">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="flex flex-col sm:flex-row gap-5 bg-background-100 rounded-lg p-4 md:p-5 cursor-pointer group"
            >
              <div className="w-full sm:w-56 shrink-0 aspect-video sm:aspect-auto sm:h-32 rounded-md overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-center gap-2 mb-2">
                  <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded">
                    {item.category}
                  </span>
                  <span className="text-xs text-foreground-400">{item.duration}</span>
                  <span className="text-xs font-medium text-accent-600 bg-accent-50 px-2 py-0.5 rounded">
                    {item.quality}
                  </span>
                </div>
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500 mt-2">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views} 次观看
                  </span>
                  <span className="flex items-center gap-1 cursor-pointer">
                    <i className="ri-heart-line"></i>
                    收藏
                  </span>
                  <span className="flex items-center gap-1 cursor-pointer">
                    <i className="ri-share-forward-line"></i>
                    分享
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}